import { useState } from 'react';

type HoverProps = {
  onFocus: () => void;
  onMouseEnter: () => void;
  onBlur: () => void;
  onMouseLeave: () => void;
  onMouseMove?: () => void;
};

export type UseIsHoveredReturnType = [boolean, HoverProps, (hovered: boolean) => void];

export const useIsHovered = (): UseIsHoveredReturnType => {
  const [isHovered, setIsHovered] = useState(false);

  const onFocus = () => setIsHovered(true);
  const onMouseEnter = () => setIsHovered(true);
  const onMouseMove = () => setIsHovered(true);
  const onBlur = () => setIsHovered(false);
  const onMouseLeave = () => setIsHovered(false);

  const hoverProps: HoverProps = {
    onFocus,
    onMouseEnter,
    onBlur,
    onMouseLeave,
  };

  if (!isHovered) {
    hoverProps.onMouseMove = onMouseMove;
  }

  return [isHovered, hoverProps, setIsHovered];
};
